var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('detail',{attrs:{"envName":"种植环境","envInfoType":1}})}
var staticRenderFns = []

export { render, staticRenderFns }